import { S2ResponseLikeInterface } from 'libs/end-to-end/src/interfaces';
import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';
import { Result } from 'libs/end-to-end/src/result';
import { WithMeta } from 'libs/end-to-end/src/result';
import { errResult } from 'libs/end-to-end/src/result';
import { okResult } from 'libs/end-to-end/src/result';
import { withMeta } from 'libs/end-to-end/src/result';
import { createZodParseError } from 'libs/end-to-end/src/utils/utility/create-zod-parse-error';
import { ResponseToJsonError } from 'libs/end-to-end/src/types/errors/response-to-json-error';

export const responseToJson = async <TSchema>(props: {
  response: S2ResponseLikeInterface;
  schema: S2SafeParsable<unknown, TSchema>;
}): Promise<WithMeta<Result<TSchema, ResponseToJsonError>, unknown>> => {
  const { response, schema } = props;
  let resultAny: unknown;
  try {
    resultAny = await response.json();
  } catch (e) {
    return withMeta(
      errResult({
        errorType: 'ResponseParseJsonError',
        errorReason: e instanceof Error ? e.message : 'Unknown error',
      }),
      null,
    );
  }

  const parseResult = schema.safeParse(resultAny);

  if (!parseResult.success) {
    return withMeta(errResult(createZodParseError(parseResult)), resultAny);
  }

  return withMeta(okResult(parseResult.data), resultAny);
};
